import _ from "lodash";
import Radium from "radium";
import React from "react";

import { styles } from "@common/styles";
import { IUser } from "@common/models";

import AdminUserHeader from "./admin-user-header";
import ApiKey from "./api-kyes";
import DeviceList from "./device";
import Authorization from "./authorization";
import UserProfile from "./profile";

export interface IAdminUserProps {
  user: IUser;
}

export interface IAdminUserActions {
  navigateBack: () => void;
}
export interface IAdminUserState {}

export class AdminUser extends React.Component<
  IAdminUserProps & IAdminUserActions,
  IAdminUserState
> {
  constructor(props) {
    super(props);

    this.state = {
      adminUserIsChecked: false,
      apiUserIsChecked: false,
      apikey: undefined,
      basicUserIsChecked: false,
      device: undefined,
      isOpen: false,
      newClaims: [],
      newExpireDate: "",
      newName: "",
      oldExpireDate: "",
      oldName: "",
      remoContent: undefined,
      user: undefined
    };
  }

  public render() {
    return (
      <div
        className="flexColumnContent"
        style={styles.flexColumnContent as any}
      >
        <AdminUserHeader navigateBack={this.props.navigateBack} />
        <div
          className="contentContainer"
          style={styles.contentContainer as any}
        >
          <div className="flexList">
            <div className="headerRow" style={styles.headerRow as any}>
              <div>
                {this.props.user.name
                  ? this.props.user.name
                  : this.props.user.username}
              </div>
            </div>
            <UserProfile {...this.props} />
            <Authorization {...this.props.user} />
            <ApiKey {...this.props.user} />
            <DeviceList {...this.props.user} />
          </div>
        </div>
      </div>
    );
  }
}

export default Radium(AdminUser);
